import { api } from "../../api";
import { CreateOrderRequestTypes } from "../interface";

/**
 * Совместимая обёртка legacy WebApp → zero-api.
 * Бэк принимает только { sellCurrency, buyCurrency, sellAmount, comment? } на POST /orders/exchange,
 * остальные данные (телефон, промокод, счёт зачисления, метод оплаты) кладём в комментарий,
 * чтобы менеджер видел всё в одном месте.
 */
export async function CreateOrder(
  data: CreateOrderRequestTypes,
): Promise<CreateOrderRequestTypes> {
  const extras: string[] = [];
  if (data.phone_number) extras.push(`Телефон: ${data.phone_number}`);
  if (data.payment_method) extras.push(`Оплата: ${data.payment_method}`);
  if (data.receive_method) extras.push(`Получение: ${data.receive_method}`);
  if (data.payment_city) extras.push(`Город оплаты: ${data.payment_city}`);
  if (data.receive_city) extras.push(`Город получения: ${data.receive_city}`);
  if (data.account_id !== null && data.account_id !== undefined) {
    extras.push(`Реквизиты: ${data.account_id}`);
  }
  if (data.rate) extras.push(`Курс: ${data.rate}`);
  if (data.buy_amount !== undefined) {
    extras.push(`Получит: ${data.buy_amount} ${data.buy_currency}`);
  }
  if (data.comment) extras.push(`Комментарий: ${data.comment}`);

  const payload = {
    sellCurrency: data.sell_currency,
    buyCurrency: data.buy_currency,
    sellAmount: String(data.sell_amount ?? "0"),
    comment: extras.length ? extras.join(" | ") : undefined,
  };

  const res = await api.post("/orders/exchange", payload);
  return res.data;
}
